export default __webpack_public_path__ + "static/media/proxy-hint-dark.d096fd63.svg";